import React from 'react';

import { useIntl } from 'react-intl';

import AkFlag, { type FlagProps } from '@atlaskit/flag';
import ErrorIcon from '@atlaskit/icon/core/status-error';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { withLocalIntl } from '../../common/utils/i18n/intl-provider';

import { messages } from './messages';

export type Props = {
	id: FlagProps['id'];
	onDismiss: FlagProps['onDismissed'];
};

const SUPPORT_LINK = 'https://support.atlassian.com/contact/';

export const InviteErrorFlag: (props: Props) => React.JSX.Element = withLocalIntl(
	({ onDismiss, ...props }: Props) => {
		const { formatMessage } = useIntl();

		return (
			<AkFlag
				{...props}
				icon={<ErrorIcon spacing="spacious" label="Error" color={token('color.icon.danger')} />}
				onDismissed={onDismiss}
				title={
					<Box as="p" xcss={subtleColorStyles}>
						{formatMessage(messages.title)}
					</Box>
				}
				description={
					<Box as="p" xcss={subtleColorStyles}>
						{formatMessage(messages.description)}
					</Box>
				}
				actions={[
					{
						content: formatMessage(messages.action),
						href: SUPPORT_LINK,
						target: '_blank',
					},
				]}
			/>
		);
	},
);

const subtleColorStyles = xcss({
	color: 'color.text.subtle',
});
